import Typography from '@mui/material/Typography';

import { BaseDialog } from '../custom-dialog';
import { BaseDialogProps } from '../custom-dialog/types';

export interface AlertModalProps {
  title?: string;
  content?: string;
  open: boolean;
  onClose: VoidFunction;
  accept?: string;
  onAccept?: VoidFunction;
  buttonColor?: BaseDialogProps['buttonColor'];
  disableBackdropClick?: boolean;
}

export default function AlertModal({
  title,
  content,
  open,
  onClose,
  accept,
  onAccept,
  buttonColor,
  disableBackdropClick,
}: Readonly<AlertModalProps>) {
  const handleClickAccept = () => {
    if (onAccept) onAccept();
    onClose();
  };

  return (
    <BaseDialog
      open={open}
      title={title}
      onClose={onClose}
      onCancel={handleClickAccept}
      cancel={accept}
      buttonColor={buttonColor}
      disableBackdropClick={disableBackdropClick}
    >
      <Typography variant="body1">{content}</Typography>
    </BaseDialog>
  );
}
